module.exports = __webpack_public_path__ + "img/17_30.8c822d36.png";